import { NavLink } from 'react-router-dom';

import DashboardSwitcher from './DashboardSwitcher.jsx';

const CENTIER_LOGO =
  'https://www.centier.com/images/default-source/content-images/centier_bank_4c_adjustedhorizontal.svg';

// Sidebar quick filters → the filter patch each applies on the dashboard.
const QUICK_FILTERS = [
  { key: 'migration', icon: '🔴', label: 'Evolution Related',
    count: (s) => s?.migration_related ?? 0, patch: { is_migration_related: true } },
  { key: 'product', icon: '🏦', label: 'Product Mentions',
    count: (s) => s?.product_related ?? 0, patch: { product: 'any' } },
  { key: 'urgent', icon: '⚡', label: 'Urgent',
    count: (s) => s?.urgent_count ?? 0, patch: { is_urgent: true } },
  { key: 'glowing', icon: '⭐', label: 'Glowing',
    count: (s) => s?.by_status?.glowing ?? 0, patch: { status: 'glowing' } },
  { key: 'unreviewed', icon: '📋', label: 'Business as Usual',
    count: (s) => s?.by_status?.unreviewed ?? 0, patch: { status: 'unreviewed' } },
  { key: 'command_center', icon: '⚑', label: 'Command Center',
    count: (s) => s?.submitted_to_command_center ?? 0,
    patch: { submitted_to_command_center: true } },
];

export { QUICK_FILTERS };

function StatRow({ label, value, alert }) {
  return (
    <div className="sb-stat-row">
      <span className="sb-stat-row__label">{label}</span>
      <span className={`sb-stat-row__value${alert ? ' sb-stat-row__value--alert' : ''}`}>
        {value}
      </span>
    </div>
  );
}

export default function SentimentSidebar({
  stats,
  statsLoading = false,
  activeQuickFilter = null,
  onQuickFilter,
}) {
  const migration = stats?.migration_related ?? 0;
  const avgRating = stats?.avg_rating;
  const critical = stats?.critical_unresolved ?? 0;
  const fmt = (v) => (statsLoading ? '—' : v);
  // Overview + quick filters only make sense on the dashboard (where a
  // filter handler is wired). Other pages show just logo + nav.
  const showExtras = onQuickFilter != null;

  return (
    <aside className="sidebar">
      <div className="sidebar__header">
        <img className="sidebar__logo" src={CENTIER_LOGO} alt="Centier Bank" />
      </div>

      <DashboardSwitcher />

      <div className="sidebar__scroll">
        {showExtras && (
        <>
        <div className="sidebar__section">
          <div className="sidebar__section-label">Overview</div>
          <StatRow label="Total This Week" value={fmt(stats?.new_this_week ?? 0)} />
          <StatRow label="Evolution Related" value={fmt(migration)} alert={migration > 0} />
          <StatRow
            label="Avg Rating"
            value={statsLoading ? '—' : avgRating != null ? avgRating.toFixed(1) : '—'}
            alert={avgRating != null && avgRating < 3.5}
          />
          <StatRow label="Critical Unresolved" value={fmt(critical)} alert={critical > 0} />
        </div>

        {migration > 0 && (
          <div className="sidebar__section">
            <div className="migration-alert">
              ⚠️ {migration} Evolution-related mention{migration === 1 ? '' : 's'} flagged
            </div>
          </div>
        )}

        <div className="sidebar__section">
          <div className="sidebar__section-label">Quick Filters</div>
          <ul className="sb-quick">
            {QUICK_FILTERS.map((q) => (
              <li key={q.key}>
                <button
                  type="button"
                  className={`sb-quick__item${
                    activeQuickFilter === q.key ? ' sb-quick__item--active' : ''
                  }`}
                  onClick={() => onQuickFilter?.(q.key, q.patch)}
                  aria-pressed={activeQuickFilter === q.key}
                >
                  <span className="sb-quick__icon" aria-hidden="true">{q.icon}</span>
                  <span className="sb-quick__label">{q.label}</span>
                  <span className="sb-quick__count">
                    {statsLoading ? '—' : q.count(stats)}
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
        </>
        )}
      </div>

      <nav className="sidebar__footer" aria-label="Primary">
        <NavLink
          to="/sentiment"
          end
          className={({ isActive }) =>
            'sidebar__link' + (isActive ? ' sidebar__link--active' : '')
          }
        >
          Dashboard
        </NavLink>
        <NavLink
          to="/sentiment/reports"
          className={({ isActive }) =>
            'sidebar__link' + (isActive ? ' sidebar__link--active' : '')
          }
        >
          Reports
        </NavLink>
      </nav>
    </aside>
  );
}
